import { render } from "./tpl_flex_five.vue?vue&type=template&id=22c5d286&scoped=true"
import script from "./tpl_flex_five.vue?vue&type=script&lang=js"
export * from "./tpl_flex_five.vue?vue&type=script&lang=js"

import "./tpl_flex_five.vue?vue&type=style&index=0&id=22c5d286&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22c5d286"],['__file',"src/views/dragger/template/tpl_flex_five.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "22c5d286"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('22c5d286', __exports__)) {
    console.log('reload')
    api.reload('22c5d286', __exports__)
  }
  
  module.hot.accept("./tpl_flex_five.vue?vue&type=template&id=22c5d286&scoped=true", () => {
    console.log('re-render')
    api.rerender('22c5d286', render)
  })

}


export default __exports__